import { __decorate } from "tslib";
import { observable, makeObservable } from 'mobx';
var NavigationStore = /** @class */ (function () {
    function NavigationStore(rootStore) {
        Object.defineProperty(this, "ucfStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "isBack", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "pageRefreshed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        makeObservable(this);
        this.ucfStore = rootStore;
    }
    Object.defineProperty(NavigationStore.prototype, "setCurrentPage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (page) {
            this.currentPage = page;
        }
    });
    Object.defineProperty(NavigationStore.prototype, "setIsBack", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isBack) {
            this.isBack = isBack;
        }
    });
    Object.defineProperty(NavigationStore.prototype, "setPageRefreshed", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (refresh) {
            this.pageRefreshed = refresh;
        }
    });
    __decorate([
        observable
    ], NavigationStore.prototype, "ucfStore", void 0);
    __decorate([
        observable
    ], NavigationStore.prototype, "currentPage", void 0);
    __decorate([
        observable
    ], NavigationStore.prototype, "isBack", void 0);
    __decorate([
        observable
    ], NavigationStore.prototype, "pageRefreshed", void 0);
    return NavigationStore;
}());
export { NavigationStore };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmF2aWdhdGlvblN0b3JlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1N0b3JlL05hdmlnYXRpb24vTmF2aWdhdGlvblN0b3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsVUFBVSxFQUFFLGNBQWMsRUFBQyxNQUFNLE1BQU0sQ0FBQztBQUdoRDtJQU9FLHlCQUFZLFNBQW1CO1FBTm5COzs7OztXQUFtQjtRQUVuQjs7OzttQkFBYyxFQUFFO1dBQUM7UUFDakI7Ozs7bUJBQVMsS0FBSztXQUFDO1FBQ2Y7Ozs7bUJBQWdCLElBQUk7V0FBQztRQUcvQixjQUFjLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDckIsSUFBSSxDQUFDLFFBQVEsR0FBRyxTQUFTLENBQUM7SUFDNUIsQ0FBQzs7Ozs7ZUFFRCxVQUFlLElBQVk7WUFDekIsSUFBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUM7UUFDMUIsQ0FBQzs7Ozs7O2VBRUQsVUFBVSxNQUFlO1lBQ3ZCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3ZCLENBQUM7Ozs7OztlQUVELFVBQWlCLE9BQWdCO1lBQy9CLElBQUksQ0FBQyxhQUFhLEdBQUcsT0FBTyxDQUFDO1FBQy9CLENBQUM7O0lBckJXO1FBQVgsVUFBVTtxREFBb0I7SUFFbkI7UUFBWCxVQUFVO3dEQUFrQjtJQUNqQjtRQUFYLFVBQVU7bURBQWdCO0lBQ2Y7UUFBWCxVQUFVOzBEQUFzQjtJQWtCbkMsc0JBQUM7Q0FBQSxBQXZCRCxJQXVCQztTQXZCWSxlQUFlIn0=